import Colors from "../../../../global/Colors";
import { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

const STRINGS = {
  defaultTitle: "Daily KPI Summary",
  defaultUserName: "Unknown",
  defaultUserRole: "Medical Care Coordinator",
  gradientColors: [
    { percent: 0, color: Colors.sky[300] },
    { percent: 10, color: Colors.sky[500] },
    { percent: 15, color: Colors.blue[500] },
    { percent: 45, color: Colors.violet[700] },
    { percent: 80, color: Colors.purple[800] },
  ],
  navigationPaths: { SEARCH: "/search" },
  colors: {
    1: {
      backgroundColor: HNSColors.success[700],
      textColor: HNSColors.success[500],
      arrowTextColor: HNSColors.success[400],
      borderColor: HNSColors.success[600],
    },
    2: {
      backgroundColor: HNSColors.failure[700],
      textColor: HNSColors.failure[500],
      arrowTextColor: HNSColors.failure[500],
      borderColor: HNSColors.failure[600],
    },
  },
  arrows: {
    1: SvgEnum.HisArrowUp,
    2: "",
    3: SvgEnum.HisArrowDown,
  },
};

export default STRINGS;
